import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';


import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';

import { StepperComponent } from './stepper.component';
import { BreadcrumbService } from '../../services/breadcrumb.service';

@NgModule({
  imports: [
    CommonModule,
    
    MatButtonModule,
    MatIconModule,
    MatStepperModule
  ],
  exports: [
    StepperComponent
  ],
  providers: [
    BreadcrumbService
  ],
  declarations: [
    StepperComponent
  ]
})
export class StepperModule { }
